import React from 'react';

const Loading = () => {
  return (
      <div>
        <p>...reloading</p>
      </div>
  )
}

export default Loading;